import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_SHIP_TO_ADDRESS_SUCCESS,
    GET_SHIP_TO_ADDRESS_FAILURE,
} from '../actions';
import { accountNumberZeroTrimmer, convertObjectToQueryParams } from 'src/utils/util';

export default function* getShipToAddress(action) {
    // const sapPartnerId = yield select(
    //     (state) => state.consignmentAddReducer.consignmentAddDetails.accountId.accountId
    // );
    const billToShipToPartnerRole = yield select((state) =>
        state.loginReducer.billToShipToPartnerRole
    );
    const sapPartnerIdOtherUser = yield select(
         (state) => state.consignmentAddReducer.consignmentAddDetails.accountId.accountId
      );
     const sapPartnerIdJapanUser = yield select(
         (state) => state.consignmentAddReducer.consignmentAddDetails.billToId?.billToNumber
     );
     const sapPartnerIdResult = function (){
         if(billToShipToPartnerRole == 'BILL_TO'){
             return sapPartnerIdJapanUser;
         }
         else 
         return sapPartnerIdOtherUser;
     };
    const sapPartnerId = sapPartnerIdResult();

    const selectedAccount = yield select((state) => state.replenishAccount);

    const objParams = {
        sapPartnerId:
            selectedAccount.selectedAccount !== undefined
                ? selectedAccount.selectedAccount.accountId
                : sapPartnerId,
        ...action.payload,
    };

    const isFalsyValueRequired = false;

    // const url = `occ/v2/${localStorage.getItem(
    //     'baseSiteId'
    // )}/order/surgery/shiptoaddress?sapPartnerId=${selectedAccount.selectedAccount!==undefined ? selectedAccount.selectedAccount.accountId :sapPartnerId}`;

    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/shiptoaddress?${convertObjectToQueryParams(
        objParams,
        isFalsyValueRequired
    )}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        const updatedResult =  { ...result,
            shipToData: {
                ...result.shipToData,
                nonTissueAddress: result.shipToData?.nonTissueAddress?.map((item) => {
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                }),
                tissueAddress: result.shipToData?.tissueAddress?.map((item)=>{
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                })
            },
        };
        yield put({
            type: GET_SHIP_TO_ADDRESS_SUCCESS,
            payload: updatedResult.shipToData || [],
            statusCode: updatedResult.statusCode,
            statusMessage: updatedResult.statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_SHIP_TO_ADDRESS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
